import styled from 'styled-components';

interface BaseProps {
	isMobile: boolean;
	sidebarVisible: boolean;
	sidebarDocked: boolean;
	sidebarWidth: number;
}

export const Base = styled.div<BaseProps>`
	position: relative;
	height: 100vh;
	background-color: ${({ theme }) => theme.gray[0]};

	${({ isMobile, sidebarDocked, sidebarWidth }) =>
		isMobile
			? `
		display: block;
	`
			: `
		display: grid;
		grid-template-columns: ${sidebarDocked ? `${sidebarWidth}px 1fr` : '0 1fr'};
		transition: none;
	`}
`;

export const VersionBanner = styled.div`
	position: fixed;
	bottom: 16px;
	right: 16px;
	z-index: 99999;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 10px 14px;
	background: linear-gradient(
			${({ theme }) => `${theme.blue[500]}14`},
			${({ theme }) => `${theme.blue[500]}14`}
		),
		${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[400]};
	border-radius: 6px;
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	line-height: 1.4;

	a {
		color: ${({ theme }) => theme.blue[600]};
		text-decoration: underline;
		text-underline-offset: 2px;
		transition: color 0.15s ease;
		&:hover {
			color: ${({ theme }) => theme.blue[800]};
		}
	}

	button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		height: 20px;
		padding: 0;
		background: none;
		border: none;
		color: ${({ theme }) => theme.gray[400]};
		border-radius: 4px;
		flex-shrink: 0;
		transition: all 0.15s ease;
		&:hover {
			color: ${({ theme }) => theme.gray[700]};
			background-color: ${({ theme }) => theme.gray[200]};
		}
	}
`;

interface MainContentProps {
	isMobile: boolean;
	sidebarVisible: boolean;
	sidebarWidth: number;
}

export const MainContent = styled.div<MainContentProps>`
	height: 100vh;
	overflow: hidden;
	position: relative;

	${({ isMobile, sidebarVisible, sidebarWidth }) =>
		isMobile
			? `
		width: 100%;
		transform: ${sidebarVisible ? `translateX(${sidebarWidth}px)` : 'none'};
		transition: transform 0.3s ease;
		backdrop-filter: ${sidebarVisible ? 'blur(2px)' : 'none'};
	`
			: `
		grid-column: 2;
	`}
`;
